"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldValidateOptions = exports.SingleAnswerFormField = exports.MultipleAnswerFormField = exports.BaseFormField = void 0;
const class_validator_1 = require("class-validator");
const utils_1 = require("../../../../utils");
const typings_1 = require("./typings");
class BaseFormField {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.BaseFormField = BaseFormField;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], BaseFormField.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], BaseFormField.prototype, "question", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], BaseFormField.prototype, "fieldType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], BaseFormField.prototype, "isHeader", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], BaseFormField.prototype, "signature", void 0);
class MultipleAnswerFormField extends BaseFormField {
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
exports.MultipleAnswerFormField = MultipleAnswerFormField;
__decorate([
    (0, class_validator_1.IsIn)(typings_1.multipleAnswerFieldTypes),
    __metadata("design:type", String)
], MultipleAnswerFormField.prototype, "fieldType", void 0);
__decorate([
    utils_1.IsNestedArray.ofStringsOrArrayOfStrings(),
    __metadata("design:type", Array)
], MultipleAnswerFormField.prototype, "answerArray", void 0);
class SingleAnswerFormField extends BaseFormField {
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
exports.SingleAnswerFormField = SingleAnswerFormField;
__decorate([
    (0, class_validator_1.IsIn)(typings_1.singleAnswerFieldTypes),
    __metadata("design:type", String)
], SingleAnswerFormField.prototype, "fieldType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SingleAnswerFormField.prototype, "answer", void 0);
const generateDiscriminatorSubtypes = (arr, cls) => {
    return arr.map((str) => {
        return {
            value: class AnswerFormField extends cls {
                constructor() {
                    super(...arguments);
                    this.fieldType = str;
                }
            },
            name: str,
        };
    });
};
exports.FormFieldValidateOptions = {
    keepDiscriminatorProperty: true,
    discriminator: {
        property: "fieldType",
        subTypes: [
            ...generateDiscriminatorSubtypes(typings_1.singleAnswerFieldTypes, SingleAnswerFormField),
            ...generateDiscriminatorSubtypes(typings_1.multipleAnswerFieldTypes, MultipleAnswerFormField),
        ],
    },
};
//# sourceMappingURL=api-domain.js.map